import ApiCore from '@/api/index';

const CollectorApi = ApiCore(`//collector1.sooplive.co.kr`, false);
export default CollectorApi;
